'use client';
import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import { analytics } from '~/analytics';
import { useAuth } from '~/auth/hooks';
import { isProduction } from '~/stage';

if (typeof window !== 'undefined' && isProduction()) {
  posthog.init('phc_5m7sVL1fqU6GvBsYllWtlnut7P60YtaMN2fTlqSarY1', {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    person_profiles: 'identified_only',
  });
}

export function Pageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname;

      // eslint-disable-next-line
      if (searchParams?.toString()) {
        url = url + `?${searchParams.toString()}`;
      }

      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return <></>;
}

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      analytics.identify(user);
    }
  }, [user]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
